/**
 * List component
 * @param {string[]} steps - The list of steps to render
 * @param {boolean} [noPadding=false] - Whether to remove padding from the list
 * @param {number} [fontSize=9] - The font size of the list items
 * @param {object} [color] - The color object to apply to the list items
 * @param {boolean} [showBullets=true] - Whether to show bullets before the list items
 */

import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { getColorObjectStyle } from 'PDF/helpers/documentStyle';

interface IListProps {
  steps: string[];
  noPadding?: boolean;
  fontSize?: number;
  color?: Record<string, string>;
  showBullets?: boolean;
  withBottomMargin?: boolean;
}

export const List = ({
  steps,
  noPadding = false,
  fontSize = 9,
  color = getColorObjectStyle(12, 'color'),
  showBullets = true,
  withBottomMargin = false,
}: IListProps) => {
  if (!steps.length) {
    return null;
  }
  return (
    <View style={[styles.ceilWrapper, { marginBottom: withBottomMargin ? '30px' : 0 }]}>
      {steps.map((step: string, index: number) => (
        <View
          minPresenceAhead={30}
          key={index}
          style={[{ marginBottom: noPadding || index === steps.length - 1 ? 0 : 6 }, styles.listItemWrapper]}
        >
          {showBullets && <Text style={[styles.listItemPoint, color]}>&#8226;</Text>}
          <Text style={[styles.listItem, { fontSize, marginLeft: showBullets ? '6px' : '0' }]}>{step}</Text>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  ceilWrapper: {
    maxWidth: '100%',
  },
  listItemWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  listItem: {
    fontFamily: 'Noto',
    fontWeight: 300,
    color: '#212121',
    marginLeft: 6,
    fontSize: '9px',
    lineHeight: 1.3,
  },
  listItemPoint: {
    fontSize: 10,
  },
});
